module.exports = __webpack_public_path__ + "img/logoedus_w.d8985419.png";